
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Languages } from "lucide-react"
import { useTranslation } from "@/hooks/use-translation"
import { Language, getSupportedLanguages } from "@/i18n"

export function LanguageToggle() {
  const { language, setLanguage, t } = useTranslation()

  const languageNames: Record<Language, string> = {
    es: "Español",
    en: "English",
    fr: "Français",
  }

  const supportedLanguages = getSupportedLanguages()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className="border-border/40 hover:border-border/60 hover:bg-accent/10"
        >
          <Languages className="h-4 w-4" />
          <span className="sr-only">{t("language.toggle")}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{t("language.toggle")}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup value={language} onValueChange={(value) => setLanguage(value as Language)}>
          {supportedLanguages.map((lang) => (
            <DropdownMenuRadioItem key={lang} value={lang}>
              {languageNames[lang]}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
